import { Icons, Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import styled from 'styled-components';
import StarRating from '~/components/Location/StarRating';
import { biggerThanOrEqualTo, smallerThan } from '~/core/util/styledComponents';

const MobileStars = styled(Icons.StarFilled).withConfig({ componentId: 'sc-1o1aija-0' })`
  ${biggerThanOrEqualTo.lg`
    display: none;
  `}
`;
const DesktopStars = styled.div.withConfig({ componentId: 'sc-1o1aija-1' })`
  span {
    display: flex;
  }
  ${smallerThan.lg`
    display: none;
  `}
`;

const Rating = ({
  rating,
  ratingCount,
  showCompact,
}: {
  rating: number;
  ratingCount: number;
  showCompact?: boolean;
}) => (
  <Stack alignContent="center" alignItems="center" row space={0.5}>
    <>
      <MobileStars size="sm" textColor="peach" />
      {!showCompact && (
        <Text as="span" pr={0.5} textColor="peach" variant="subtitle2">
          {rating.toFixed(1)}
        </Text>
      )}
      <DesktopStars>
        <StarRating
          containerClassName="foo"
          showCompact={showCompact}
          showEmptyRating
          size={16}
          starRating={rating}
        />
      </DesktopStars>
      {showCompact && (
        <Text as="span" pr={0.5} textColor="peach" variant="subtitle2">
          {rating.toFixed(1)}
        </Text>
      )}
    </>
    <Text as="span" muted variant="body2">
      ({ratingCount} ratings)
    </Text>
  </Stack>
);

export default Rating;
